<div class="flex-fill container-fluid">
    <div class="d-flex flex-column gap-8">
        <div class="row">
            <div class="col-12 px-0">
                <div class="alert bg-oddr-10 mb-0 d-flex align-items-center gap-6">
                    <img alt="Verify" src="/assets/images/icons/info-oddr.svg" height="25px" width="25px" />
                    <div class="d-flex flex-column">
                        <span class="fw-semi-bold text-static-dark">ODDR signed &amp; ready to share</span>
                        <span class="fs-6 text-static-dark">A signed copy of your video has been generated and the public ODDR page will be available shortly for viewing.</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- Left column -->
            <div class="col-12 col-lg-8 px-0 pe-lg-4 d-flex flex-column gap-6">
                <div class="card">
                    <img alt="Media thumbnail" [src]="$safeNavigationMigration(operation?.thumbnailUrl)" class="card-img-top">
                </div>
            </div>

            <!-- Right column -->
            <div class="col-12 col-lg-4 px-0 ps-lg-4 d-flex flex-column gap-6">
                <div class="card">
                    <div class="card-body d-flex flex-column gap-6">
                        <h4 class="fw-semi-bold">Video properties</h4>
                        <div class="d-flex align-items-start gap-6">
                            <img alt="Title" [src]="resolveImageIcon('typography')" height="24px" width="24px" />
                            <div class="d-flex flex-column">
                                <span class="fw-semi-bold">Title</span>
                                <span class="fs-7 text-muted">{{ operation?.title }}</span>
                            </div>
                        </div>
                        <div class="d-flex align-items-start gap-6">
                            <img alt="ODDR link" [src]="resolveC2paStatusIcon($safeNavigationMigration(pollingStatusUpdate?.c2paStatus))" height="24px" width="24px" />
                            <div class="d-flex flex-column">
                                <span class="fw-semi-bold">Signature status</span>
                                <span class="fs-7 text-muted">{{ pollingStatusUpdate?.c2paStatus }}</span>
                            </div>
                        </div>
                        <div class="d-flex align-items-start gap-6">
                            <img alt="ODDR link" [src]="resolveImageIcon('pages')" height="24px" width="24px" />
                            <div class="d-flex flex-column">
                                <span class="fw-semi-bold">ODDR link</span>
                                <span class="fs-7 text-muted">{{ oddrLink }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body d-flex flex-column gap-6">
                        <h4 class="fw-semi-bold">Integrations</h4>
                        @if (selectedIntegrations.length > 0) {
                            <div class="d-flex flex-column gap-3">
                                @for (integration of selectedIntegrations; track integration.id) {
                                    <div class="d-flex align-items-center gap-3">
                                        <span class="fs-6">{{ integration.label }}</span>
                                    </div>
                                }
                            </div>
                        }
                        @else {
                            <div class="alert alert-info mb-0 d-flex align-items-center gap-6">
                                <img alt="Info" src="/assets/images/icons/info-blue.svg" height="25px" width="25px" />
                                <div class="d-flex flex-column">
                                    <span class="fw-semi-bold">No integrations selected</span>
                                    <span class="fs-6">You have not chosen any services to upload your video to.</span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="card">
                    <div class="card-body d-flex flex-column">
                        <h4 class="fw-semi-bold">Your signed asset &amp; proof of ownership</h4>
                        <span class="fs-7 mb-6 text-muted">Your public ODDR link is your permanent proof of ownership — it stays valid whether you upload to social media or download and post the asset yourself.</span>
                        <div class="mb-6">
                            <span class="fs-7 fw-semi-bold d-block mb-3">Prefer to post it yourself?</span>
                            <ol class="fs-7 text-muted mb-0 ps-6 d-flex flex-column gap-2">
                                <li>Download your ODDR-signed (C2PA-backed) media asset below.</li>
                                <li>Upload it to any platform you like.</li>
                                <li>Paste your proof-of-ownership link into the caption so viewers can verify it.</li>
                            </ol>
                        </div>
                        <div class="d-flex flex-column gap-6">
                            <pp-button [shape]="buttonShape.Square"
                                [size]="buttonSize.Sm"
                                [variant]="buttonVariant.Primary"
                                (buttonClick)="downloadC2paSignedCopy()">Download your signed media asset</pp-button>
                            <pp-button [shape]="buttonShape.Square"
                                [size]="buttonSize.Sm"
                                [variant]="buttonVariant.Secondary"
                                (buttonClick)="copyThumbnailUrlToClipboard()">Copy your proof-of-ownership link</pp-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="d-flex justify-content-between align-items-center mt-6 gap-10">
    <ng-container *ngTemplateOutlet="uploadStatusIndicator" />
    <div class="d-flex justify-content-end">
        <pp-button [shape]="buttonShape.Square"
            [variant]="buttonVariant.Primary"
            (buttonClick)="submitAndCompleteFlow()">Upload</pp-button>
    </div>

    <ng-template #uploadStatusIndicator>
        @if (uploadProgress > 0 && !uploadComplete()) {
            <div class="upload-progress-inline d-flex align-items-center gap-6">
                <span class="fs-6 fw-semi-bold text-nowrap">Uploading... {{ uploadProgress }}%</span>
                <div class="upload-progress-bar-track">
                    <div class="upload-progress-bar-fill" [style.width.%]="uploadProgress"></div>
                </div>
            </div>
        } @else if (uploadComplete() && !processingComplete()) {
            <div class="d-flex align-items-center gap-3">
                <img alt="Processing" [src]="resolveImageIcon('time')" height="24px" width="24px" />
                <span class="fs-6 fw-semi-bold text-nowrap">Processing...</span>
            </div>
        } @else if (processingComplete()) {
            <div class="d-flex align-items-center gap-3">
                <img alt="Ready" src="/assets/images/icons/check-circle-solid-primary.svg" height="24px" width="24px" />
                <span class="fs-6 fw-semi-bold text-nowrap">Your media is ready to upload!</span>
            </div>
        } @else {
            <div></div>
        }
    </ng-template>
</div>
